import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '../models/language.model';

@Pipe({ name: 'transformLanguage' })
export class LanguagesPipe implements PipeTransform {
  preferredLanguage: Language[] = [
    new Language(1, 'Français', 'fr', 'fr'),
    new Language(2, 'Deutsch', 'de', 'de'),
  ];

  transform(userLang: string): string {
    return this.preferredLanguage.find(lang => lang.acronym === userLang).name;
  }
}
